var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card-text",
    [
      _c(
        "v-timeline",
        { attrs: { "align-top": "", dense: "" } },
        [
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", { attrs: { cols: "6" } }, [
                    _vm._v(
                      "Drag primary controls to change the overall form of a body section"
                    ),
                  ]),
                  _c(
                    "v-col",
                    [
                      _c("v-img", {
                        attrs: {
                          src: "/day6-workflow/editor-pose-control.svg",
                          "max-width": "128",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", { attrs: { cols: "6" } }, [
                    _vm._v(
                      "Double click a primary control to toggle secondary controls for finer pose control"
                    ),
                  ]),
                  _c(
                    "v-col",
                    [
                      _c("v-img", {
                        attrs: {
                          src: "/day6-workflow/tune-pose-section.png",
                          "max-width": "128",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", [
                    _vm._v(
                      "Fix pose to body options move the pose section with the body center"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-4",
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                          },
                        },
                        [_c("v-icon", [_vm._v("share")])],
                        1
                      ),
                      _vm._v("copies a link for sharing the posed character"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-4",
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                          },
                        },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.mdiHuman))])],
                        1
                      ),
                      _vm._v("opens "),
                      _c(
                        "a",
                        {
                          staticClass: "accent--text",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$emit("show-info-generate")
                            },
                          },
                        },
                        [_vm._v("Character Modeling")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }